import { Skeleton } from "@circleco/compass/components/Skeleton";

export const MemberChecklistLoading = () => (
  <div>
    <div className="mb-4 flex flex-col gap-2">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-2" />
    </div>
    <div className="flex flex-col gap-2">
      {Array.from({ length: 5 }, (_, index) => (
        <Skeleton key={index} className="h-12" />
      ))}
    </div>
  </div>
);
